import { useQuery } from '@tanstack/react-query';
import { getUserPaymentInfo } from '@features/Stripe/api';
import type { AxiosError } from 'axios';

type UserPaymentInfo = {
  user_email: string;
  user_id: string;
  app: string;
  currency: string;
  country_code: string | null;
};

export const useGetUserPaymentInfo = ({
  userId,
  email,
}: {
  userId: number | string | undefined;
  email: string | undefined;
}) => {
  return useQuery<UserPaymentInfo, AxiosError<{ error: string }>>({
    queryKey: ['user-payment-info', userId, email],
    queryFn: () => getUserPaymentInfo({ email: email!, userId: userId! }),
    enabled: !!userId && !!email,
    staleTime: 10 * 1000 * 60,
    gcTime: 10 * 1000 * 60,
    retry: 2,
  });
};
